import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {MrpProcessTemplateContainerModel} from '../../../../../../models/aggregates/mrp-prodsys';
import {ApiResponseModel, ApiVisa} from '../../shared';
import { FilesDetailsRequest } from '../../../../../../models/file-image';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MrpProcessTemplateService extends BaseApiTemplateService<MrpProcessTemplateContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-templates"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-templates"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-templates"
    this.httpClient = http;
  }

  addMrpAttachmentsAndDetails(guid: string, files: File[], visa: ApiVisa, param_code: string,
      filesDetails?: FilesDetailsRequest) {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
  
      const formData: FormData = new FormData();
      files.forEach(file => formData.append('files', file));
      if (filesDetails) {
        formData.set(
          'data',
          new Blob([JSON.stringify(filesDetails)], { type: 'application/json' }),
          'data.json')
      }
      formData.append('ext-param-code',param_code);
  
      return this.httpClient.put<ApiResponseModel<any>>(
        this.apiUrl + '/add-files/' + guid,
        formData,
        this.getHttpHeader(visa)
      );
    }

    bultItemReplace(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
      let customUrl;
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
        customUrl = this.apiUrl + '/bulk-update-template-items/backoffice-ep';
      }
      return this.httpClient.put<ApiResponseModel<any>>(
        customUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }

}
